import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import settingsSlice from 'store/modules/settings';
import { THEME_MODES } from 'common/theme/themeMode';

/**
 * Lógica compartida del cambio de tema (AppBar, login y sidebar).
 *
 * - Aplica el cambio al instante (Redux + espejo en localStorage) vía `setThemeMode`.
 * - Si hay sesión iniciada, además lo persiste en el backend (settings.theme_mode)
 *   para sincronizar entre dispositivos. Fuera de la app (login) queda solo en local.
 */
export default function useThemeMode() {
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => state.settings.config.themeMode);
  const settingsId = useSelector((state) => state.auth.user?.settings?.id);

  const isDark = themeMode === THEME_MODES.dark;

  const toggle = useCallback(() => {
    const nextMode = isDark ? THEME_MODES.light : THEME_MODES.dark;
    dispatch(settingsSlice.actions.setThemeMode(nextMode));
    if (settingsId) {
      dispatch(settingsSlice.actions.update({ id: settingsId, input: { theme_mode: nextMode } }));
    }
  }, [dispatch, isDark, settingsId]);

  return { isDark, toggle };
}
